//////////////////////////////////////////////////////////////
// Archive AJAX
//////////////////////////////////////////////////////////////


function persistFilterSelection(){
    jQuery.each(globalFilterTypes, function(index, type) { 
        const arr = retrieveURLParams(type);
        if(arr.length > 0){ jQuery('.archive-filter-item.default[data-taxonomy="'+type+'"]').removeClass('active'); }
        jQuery('.archive-filter-item[data-taxonomy="'+type+'"]').each(function(index) {
            const obj = jQuery(this);
            const termid = jQuery(this).attr('data-termid');
            if (arr.includes(termid)) {
                obj.addClass('active')
            }
        });
    });
    setTimeout(function(){
        archiveShowActionButtons();
    },500)
}

function archiveShowActionButtons() {
    
    const style_params = new URLSearchParams(window.location.search);
    const style_dlm = style_params.get('style');
    let style_arr = [];
    if (style_dlm !== null) {
        style_arr = style_dlm.split(',');
    }
    const cut_params = new URLSearchParams(window.location.search);
    const cut_dlm = cut_params.get('cut');
    let cut_arr = [];
    if (cut_dlm !== null) {
        cut_arr = cut_dlm.split(',');
    }

    let all_arr = [];
    all_arr = style_arr.concat(cut_arr);        

    const sel_arr = [];
    jQuery('.js-archive-filter-item.active:not(.default)').each(function(index, element) {
        const obj = jQuery(this);
        const id = obj.attr('data-termid');
        sel_arr.push(id);
    });

    if(arraysHaveSameValues(all_arr, sel_arr)){
        jQuery('.archive-filter-action').removeClass('active');
    }else{
        jQuery('.archive-filter-action').addClass('active');
    }
    
    
}

function arraysHaveSameValues(arr1, arr2) {
  return Array.isArray(arr1) &&
         Array.isArray(arr2) &&
         arr1.length === arr2.length &&
         arr1.slice().sort().every((val, i) => val === arr2.slice().sort()[i]);
}

function retrieveURLParams(type){
    const params = new URLSearchParams(window.location.search);
    const dlm = params.get(type);
    return (dlm !== null)? dlm.split(','): '';
}
function addURLParam(type, val){
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set(type, val);
    window.history.pushState({ type: val }, '', newUrl);
}
function deleteURLParam(type){
    const params = new URLSearchParams(window.location.search);
    params.delete(type);
    const separator = (params.toString())? '?': '';
    const newUrl = window.location.pathname + separator + params.toString();  
    window.history.pushState({}, '', newUrl);
}

function retrieveExistingFilter(){
    let arr = [];
    jQuery.each(globalFilterTypes, function(key, type) {
        arr[type] = [];
        jQuery('.archive-filter-item.active[data-taxonomy="'+type+'"]').each(function(index, element) {
            const termId = jQuery(this).attr('data-termid');
            if(termId.length > 0){
                arr[type].push(termId);
            }
        });
    })
    return arr;
}

function archiveDisplayPreloader(bool){
    if(bool){
        jQuery('.js-archive-preloader').show(300);
    }else{
        jQuery('.js-archive-preloader').hide(300);
    }
}
function loadArchive(page = 1, filter = [], cpt = 'recipe', init = false ) {
    archiveDisplayPreloader(true);
    let jsonvar =  { action: 'recipe_archive_ajax_pagination','pg': page,'style': JSON.stringify(filter.style),'cut': JSON.stringify(filter.cut) };
    if(cpt == 'product'){
        jsonvar =  { action: 'product_archive_ajax_pagination','pg': page,'range': JSON.stringify(filter.range),'cut': JSON.stringify(filter.cut) };
    }
    jQuery.ajax({
        url: main_ajax_obj.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: jsonvar,
        success: function(response) {
            loadArchiveLoop(page,response,cpt,init);
        },
        error: function(xhr, status, error) {
            console.error('AJAX Error:', error);
            alert('There was a problem loading recipes.');
            archiveDisplayPreloader(false);
        }
    });
}


function loadArchiveLoop(pagenum,response,cpt,init=false){
    
    if(response.status == 'found'){
        let htm = '';
        jQuery.each(response.data, function(key, value) { 
            const data = value.data;
            htm += `
            <div class="archive-content-item ${cpt} position-relative col-6 col-lg-4 col-xl-3 gx-6">
                <a href="${value.permalink}">
                    <img src="${value.thumbnail}" alt="">
                    <div class="archive-content-item-footer">
                        <div class="archive-content-item-footer-title">${cpt === 'product' ? `<h3>${value.title}</h3>` : `<h4>${value.title}</h4>`}</div>
                        <div class="archive-content-item-footer-icon">
                            <i class="icon icon-forward"></i>
                        </div>
                    </div>
                </a>
            </div>
            `;
        });
        jQuery('.js-archive-content').html(htm);
        updateArchivePagination(response.pagination);
        updateArchiveParams('pg',pagenum);
        archiveDisplayPreloader(false);
        archiveShowActionButtons();
        if(!init){
            jQuery('html, body').scrollTop(jQuery('.section-archive-wrapper').offset().top - 80);
        }

        if(parseInt(response['max-pages']) > 1){
            jQuery('.js-archive-pagination').removeClass('hide');
        }else{
            jQuery('.js-archive-pagination').addClass('hide');
        }
    }else{
        jQuery('.js-archive-content').html('<div class="archive-content-nothing">No recipes found.</div>');
        archiveDisplayPreloader(false);
    }
}

function updateArchiveParams(param,val){
    if(param == 'pg'){
        if(val > 1 && val ){
            addURLParam(param,val);
        }else{
            deleteURLParam(param);
        }
    }
    if(param == 'style'){
        if(val){
            addURLParam(param,val);
        }else{
            deleteURLParam(param);
        }
    }
    if(param == 'range'){
        if(val){
            addURLParam(param,val);
        }else{
            deleteURLParam(param);
        }
    }
    if(param == 'cut'){
        if(val){
            addURLParam(param,val);
        }else{
            deleteURLParam(param);
        }
    }
}

function updateArchivePagination(pagination){
    jQuery('.js-archive-pagination').html(pagination);
}